module.exports = __webpack_public_path__ + "media/images/front/bg_1-4542877b74c8010bcf99d092a0531950.jpg";